<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="$t('My Wallet')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>

    <div class="content">
      <div class="data">
        <div class="tit">{{ $t("Fund Details") }}</div>
        <div class="fundet">
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
          >
            <div
              class="list-wrapper"
              v-if="predeposit_list && predeposit_list.length"
            >
              <div
                class="item"
                v-for="(item, index) in predeposit_list"
                :key="item.lg_id"
              >
                <label class="subtitle">{{ item.lg_desc }}</label>
                <div class="dataTime">
                  <label class="title">{{ item.lg_addtime_text }}</label>
                  <label
                    class="date"
                    v-bind:class="item.lg_av_amount > 0 ? 'income' : 'expend'"
                  >
                    ${{ item.lg_av_amount > 0 ? "+" : ""
                    }}{{ item.lg_av_amount }}
                  </label>
                </div>
              </div>
            </div>
            <empty-record
              v-else-if="predeposit_list && !predeposit_list.length"
            ></empty-record>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from "mint-ui";
import { getMemberIndex } from "../../../api/member";
import { getGoldPredepositList } from "../../../api/memberPredeposit";
import { getBankList } from "../../../api/memberBank";
import { mapState } from "vuex";
import flexLine from "../../flexLine";
import EmptyRecord from "../../../components/EmptyRecord";
export default {
  components: {
    flexLine,
    EmptyRecord,
  },
  data() {
    return {
      voucher_count: 0,
      points: 0,
      available_rc_balance: 0,
      params: { page: 0, per_page: 10 },
      loading: false,
      isMore: true,
      predeposit_list: false,
      btnShow: true,
      bank_list: null,
    };
  },
  created() {
    this.getBankList();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    loadMore() {
      this.loading = true;
      this.params.page = ++this.params.page;
      if (this.isMore) {
        this.loading = false;
        this.getPredepositList(true);
      }
    },
    getPredepositList() {
      Indicator.open();
      getGoldPredepositList(this.params)
        .then((res) => {
          Indicator.close();
          if (res.result.hasmore) {
            this.isMore = true;
          } else {
            this.isMore = false;
          }

          let temp = res.result.list;
          if (temp) {
            if (!this.predeposit_list) {
              this.predeposit_list = temp;
            } else {
              this.predeposit_list = this.predeposit_list.concat(temp);
            }
          }
        })
        .catch(function (error) {
          Indicator.close();
          Toast(error.message);
        });
    },
    getBankList() {
      getBankList()
        .then((res) => {
          this.bank_list = res.result.bank_list;
        })
        .catch(function (error) {
          Toast(error.message);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
}

.common-header-wrap {
  .common-header {
    box-shadow: none;
  }
}

.content {
  padding: 20px;
  width: 600px;
  margin: 0 auto 0;
}

.data {
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.tit {
  margin-bottom: 20px;
  display: inline-block;
  color: black;
  padding: 0.5rem 0rem 0px;
  font-weight: bold;
  font-size: 18px;
  border-bottom: none;
  background-image: linear-gradient(
    90deg,
    #e8090c 30%,
    rgba(243, 97, 30, 0.8) 20%,
    rgba(240, 240, 240, 0.9) 70%
  );
  background-size: 100% 5px;
  background-repeat: no-repeat;
  background-position: bottom;
}
.list-wrapper {
  padding: 0.5rem;
  background: #ffffff;
  max-height: 500px;
  overflow-y: auto;
  border-radius: 10px;

  .item {
    padding: 15px;
    display: flex;
    position: relative;
    justify-content: center;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff;
    border-bottom: 1px solid #e8eaed;

    &:last-child {
      border-bottom: none;
    }

    .title {
      font-size: 14px;
      margin-bottom: 0.5rem;
    }

    .income {
      color: $primaryColor;
    }

    .expend {
      color: #333;
    }

    .subtitle {
      font-size: $fontSize;
      color: #666;
      padding-bottom: 8px;
    }
    
    .dataTime {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    
    .date {
      color: #e8090c;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
